<div style="width: 500px; height: 400px;" data-cy="task-user-group-selection-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="task-user-group-selection-header-section">
      <div class="section-header-title" data-cy="task-user-group-selection-title-text">
        Select User Group
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; overflow-y: auto; overflow-x: hidden; padding-left: 8px; padding-right: 8px;" data-cy="task-user-group-selection-content-section">
      <div class="task-group-item" (mouseover)="onMouseOver(group)" (mouseout)="onMouseOut(group)" (click)="onUserGroupSelected(group)" *ngFor="let group of data.userGroups"
           [ngClass]="{'task-group-item-selected': selectedUserGroup === group, 'task-group-item-hovered': hoveredItem === group && hoveredItem !== selectedUserGroup}" data-cy="task-user-group-selection-item">
        {{group.UserGroupName}}
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="task-user-group-selection-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="cancel()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="task-user-group-selection-cancel-button">Cancel</button>
      <button [disabled]="!selectedUserGroup" (click)="close()" class="tdo-button tdo-save" style="margin-right: 10px;" data-cy="task-user-group-selection-ok-button">Ok</button>
    </div>
  </div>
</div>
